import { render, staticRenderFns } from "./CartasTotales.vue?vue&type=template&id=d15450a8&"
import script from "./CartasTotales.vue?vue&type=script&lang=js&"
export * from "./CartasTotales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports